
const menus = [
  "CONTACT US",
  "Quick Navigation",
  "Products",
  // 'Featured'
];
export default {
  props: ["footerData", "supplyList"],
  data() {
    return {
      menus,
    };
  },
};
